import { BREAKPOINT_CLASS_PREFIX } from '../constants/breakpoints';
import type { CssModule } from '../types/cssModule';
import type { Responsive } from '../types/responsive';

import { toBreakpointEntries } from './toBreakpointEntries';

/**
 * Maps a responsive prop to the classes generated by the `each-breakpoint` Sass mixin.
 *
 * @example
 * getResponsiveClassNames(styles, 'dir', { base: 'column', md: 'row' }) // [styles['dir-column'], styles['md-dir-row']]
 */
export function getResponsiveClassNames<T extends string | number>(
    styles: CssModule,
    name: string,
    value: Responsive<T> | undefined,
): string[] {
    if (value === undefined) {
        return [];
    }

    return toBreakpointEntries(value).flatMap(([breakpoint, item]) => {
        if (item === undefined) {
            return [];
        }
        const className = styles[`${BREAKPOINT_CLASS_PREFIX[breakpoint]}${name}-${item}`];
        return className ? [className] : [];
    });
}
